module.exports = __webpack_public_path__ + "static/media/mongodb.cb4748e6.png";